"use client";

import React from "react";
import {
  wooCommerceDevelopmentHeroData,
  wooCommerceStatsData,
  wooCommerceSolutionsAndProcessData,
  wooCommerceTechnologiesData,
  wooCommerceAboutData,
  wooCommerceDevelopmentFaqs,
} from "src/utils/mock/wooCommerceDevelopmentData";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function WooCommerceDevelopmentComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const ecommProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";

    const hasTrendingTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("ecommerce"));

    return isActive && hasTrendingTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: ecommProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={wooCommerceDevelopmentHeroData} />

      <TechStats stats={wooCommerceStatsData} />

      <WhyChooseUs data={wooCommerceSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={wooCommerceTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={wooCommerceAboutData} mainTitle="About WooCommerce Development" />
        </div>
      </section>

      <FAQSection faqs={wooCommerceDevelopmentFaqs} />
      <CommonContactSection />
    </div>
  );
}
